import {
    UPDATE_DATA,
} from '../actions/CountActions';

const initialState = {
    count: -1,
    countries: {},
};

const CountReducer = (previousState, action) => {
    const state = previousState || initialState;

    switch (action.type) {
    case UPDATE_DATA:
        return {
            ...state,
            ...action.payload,
        };
    default:
        return state;
    }
};

export default CountReducer;



// WEBPACK FOOTER //
// ./reducers/CountReducer.js